export const COLORS = {
  PAPER: '#fafaf9',
  PAPER_DARK: '#eef1f4',
  TEXT: '#1a1a1a',
  INK: '#0e1c2b',
  PRIMARY: '#1890ff',
  PRIMARY_LIGHT: '#69c0ff',
  PRIMARY_DARK: '#0050b3'
};
